// extracted by mini-css-extract-plugin
module.exports = {"boxAvvenimento":"RecursiveEsitoList_boxAvvenimento__dk4Rk","containerAvvenimento":"RecursiveEsitoList_containerAvvenimento__5YKgh"};